import {request,newVue,requestMsg} from "./request";
export {newVue}

export function getCoveShedList(coveShedClassify,coveShedName,coveShedUsername,coveShedCity,pageNum,pageSize) {
  return request({
    url: '/coveShed/getCoveShedList',
    params: {
      coveShedClassify: coveShedClassify,
      coveShedName: coveShedName,
      coveShedUsername: coveShedUsername,
      coveShedCity: coveShedCity,
      pageNum: pageNum,
      pageSize: pageSize
    }
  })
}

export function delByCoveShedId(id) {
  return requestMsg({
    url: '/coveShed/delByCoveShedId',
    params: {
      id:id
    }
  })
}

export function getCoveShedAddressAll() {
  return request({
    url: '/coveShed/getCoveShedAddressAll',
    params: {
    }
  })
}

export function getCoveShedAddressByCity(labelName) {
  return request({
    url: '/coveShed/getCoveShedAddressByCity',
    params: {
      "labelName":labelName
    }
  })
}

export function getCoveShedAll(coveShedCity,coveShedCityTwo) {
  return request({
    url: '/coveShed/getCoveShedAll',
    params: {
      coveShedCity:coveShedCity,
      coveShedCityTwo:coveShedCityTwo
    }
  })
}

export function getCoveShedById(id) {
  return request({
    url: '/coveShed/getCoveShedById',
    params: {
      id:id
    }
  })
}

export function updateCoveShed(coveShed) {
  return requestMsg({
    url: '/coveShed/updateCoveShed',
    data: JSON.stringify(coveShed),
    method: "POST",
    headers : {"Content-Type" : "application/json;charset=utf-8"},
  })
}
